/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Superseded_LeadInputs */

const en_us2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There's a newer version to review.`)
};

const pt_br2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há uma versão mais nova para revisar.`)
};

const es_419_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay una versión más nueva para revisar.`)
};

const pt_pt2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há uma versão mais recente para rever.`)
};

const fr_fr2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une version plus récente est à revoir.`)
};

const de_de2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt eine neuere Version zum Prüfen.`)
};

const it_it2_draft_superseded_lead = /** @type {(inputs: Draft_Superseded_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è una versione più recente da rivedere.`)
};

/**
* | output |
* | --- |
* | "There's a newer version to review." |
*
* @param {Draft_Superseded_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_superseded_lead = /** @type {((inputs?: Draft_Superseded_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Superseded_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_superseded_lead(inputs)
	if (locale === "es-419") return es_419_draft_superseded_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_superseded_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_superseded_lead(inputs)
	if (locale === "de-DE") return de_de2_draft_superseded_lead(inputs)
	if (locale === "it-IT") return it_it2_draft_superseded_lead(inputs)
	return en_us2_draft_superseded_lead(inputs)
});
export { draft_superseded_lead as "draft.superseded_lead" }